import { useEffect, useMemo, useState } from 'react';
import type { CSSProperties } from 'react';
import { cn } from '../utils/cn';

type InitialAvatarProps = {
  name?: string | null;
  src?: string | null;
  alt?: string;
  className?: string;
  imageClassName?: string;
  style?: CSSProperties;
};

export function initialForName(name?: string | null) {
  const trimmed = String(name || '').trim();
  return trimmed ? trimmed[0].toUpperCase() : '?';
}

export default function InitialAvatar({ name, src, alt, className, imageClassName, style }: InitialAvatarProps) {
  const [loadFailed, setLoadFailed] = useState(false);
  const normalizedSrc = typeof src === 'string' && src.trim() ? src.trim() : null;
  const initial = useMemo(() => initialForName(name), [name]);

  useEffect(() => {
    setLoadFailed(false);
  }, [normalizedSrc]);

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-slate-100 text-xs font-semibold text-slate-600',
        className,
      )}
      style={style}
      aria-label={alt || name || 'Avatar'}
    >
      {normalizedSrc && !loadFailed ? (
        <img
          src={normalizedSrc}
          alt={alt || name || 'Avatar'}
          className={cn('h-full w-full object-cover', imageClassName)}
          onError={() => setLoadFailed(true)}
        />
      ) : (
        initial
      )}
    </span>
  );
}
